module.exports = __webpack_public_path__ + "img/logo-col.b40c3c18.png";